import { useState } from 'react';

export default function FAQSection() {
  const faqs = [
    {
      q: 'Что такое выявление потребностей?',
      a: 'Выявление потребностей — это ключевой этап продажи, на котором менеджер с помощью правильных вопросов и активного слушания определяет истинные задачи, проблемы и мотивы клиента. Без качественной диагностики невозможно предложить релевантное решение, и сделка либо срывается, либо закрывается с большими скидками. Это навык, которому можно и нужно обучать системно.',
    },
    {
      q: 'Почему сотрудники плохо задают вопросы?',
      a: 'Большинство менеджеров не обучены технике вопросов. Они либо сразу переходят к презентации продукта, либо задают поверхностные вопросы вроде «Что вас интересует?». Причина — отсутствие структурированной методологии (SPIN, открытые и извлекающие вопросы) и страх показаться навязчивым. Тренинг устраняет эти барьеры через практику на реальных переговорах.',
    },
    {
      q: 'Можно ли использовать SPIN?',
      a: 'Да, методика SPIN (Ситуационные, Проблемные, Извлекающие, Направляющие вопросы) — один из центральных инструментов тренинга. Мы адаптируем SPIN под специфику вашего бизнеса: B2B или B2C, длинный или короткий цикл сделки, продукт или услугу. Участники отрабатывают каждый тип вопросов на реальных кейсах своей компании.',
    },
    {
      q: 'Подходит ли тренинг для B2B?',
      a: 'Да, более 70% наших проектов — это B2B-компании. Мы обучаем выявлять потребности на разных уровнях: у лица принимающего решение, влиятельных лиц, конечных пользователей. Работаем с многоэтапными закупками, сложными продуктами и длинным циклом сделки. Учим определять не только явные, но и скрытые потребности бизнес-клиентов.',
    },
    {
      q: 'Подходит ли для B2C?',
      a: 'Да, программа адаптируется под B2C-сегмент. В розничных продажах выявление потребностей критически важно, потому что клиент часто сам не осознаёт, что ему нужно. Мы учим менеджеров через правильные вопросы помогать клиенту сформулировать его истинный запрос, что повышает и конверсию, и средний чек.',
    },
    {
      q: 'Сколько длится обучение?',
      a: 'Форматы варьируются: интенсивный тренинг — 1–2 полных дня, модульная программа — от 2 недель до 2 месяцев, комплексная программа с сопровождением — 3–6 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
    },
    {
      q: 'Можно ли проводить онлайн?',
      a: 'Да, тренинг полностью доступен в онлайн-формате: живые сессии с отработкой диалогов через видеосвязь, ролевые переговоры, детальный разбор реальных записей общения с клиентами. Онлайн-формат полностью сохраняет практическую направленность программы.',
    },
    {
      q: 'Есть ли сопровождение после тренинга?',
      a: 'Да, посттренинговое сопровождение — обязательная часть программы. Мы разбираем новые записи переговоров, поддерживаем участников в Telegram, помогаем внедрять стандарты общения. Именно сопровождение обеспечивает закрепление навыков и устойчивый рост конверсии. Без него эффективность любого тренинга падает на 70–80% уже через месяц.',
    },
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full text-left px-5 md:px-6 py-4 flex items-center justify-between gap-4 cursor-pointer group hover:bg-gray-50 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-gray-900">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === i ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-500 group-hover:bg-teal-100 group-hover:text-teal-600'}`}>
                  <i className={`text-sm transition-transform ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-out overflow-hidden ${openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-5 md:px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                  {faq.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}